import React from "react";

const Section13Governing = () => (
  <>
    <h2>13. Governing Law and Dispute Resolution</h2>
    <p>
    These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions. Any disputes arising out of or in connection with these Terms or the Service shall be subject to the exclusive jurisdiction of the courts of the United Kingdom.
    </p>

    <p>
    Before resorting to litigation, the parties agree to first attempt to resolve any dispute amicably through negotiation. If negotiation fails, the parties may consider mediation or arbitration as alternative dispute resolution methods. For claims valued under £10,000, the small claims track of the County Court in England and Wales may be an appropriate forum for resolution.
    </p>
  </>
);

export default Section13Governing;
